import {useMemo} from 'react';
import {FieldMetadata} from '@/interfaces/form';

interface SectionsMetadata {
  codeFirstSection: boolean;
  codeSecondSection: boolean;
  generalAgentSection: boolean;
}

interface UseAdvisorFormSectionMetadataProps {
  fieldsMetadata: {
    cons9_generalAgentCode: FieldMetadata;
    cons25_advisorCode: FieldMetadata;
    altAdvisorCode1: FieldMetadata;
    altAdvisorCode2: FieldMetadata;
    altAdvisorCode3: FieldMetadata;
    altAdvisorCode4: FieldMetadata;
    cons8_generalAgentName: FieldMetadata;
    cons10_generalAgentEmail: FieldMetadata;
    cons11_generalAgentEmail_confirmation: FieldMetadata;
  };
}

export const useAdvisorFormSectionMetadata = ({
  fieldsMetadata,
}: UseAdvisorFormSectionMetadataProps): SectionsMetadata => {
  return useMemo(() => {
    return {
      codeFirstSection: !(
        fieldsMetadata.cons9_generalAgentCode.isHidden &&
        fieldsMetadata.cons25_advisorCode.isHidden &&
        fieldsMetadata.altAdvisorCode1.isHidden &&
        fieldsMetadata.altAdvisorCode2.isHidden
      ),
      codeSecondSection: !(fieldsMetadata.altAdvisorCode3.isHidden && fieldsMetadata.altAdvisorCode4.isHidden),
      generalAgentSection: !(
        fieldsMetadata.cons8_generalAgentName.isHidden &&
        fieldsMetadata.cons10_generalAgentEmail.isHidden &&
        fieldsMetadata.cons11_generalAgentEmail_confirmation.isHidden
      ),
    };
  }, [fieldsMetadata]);
};
